import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'

import styles from './Tabs.module.scss'

type Title = {
  name: string
  mode: string
}

interface Props {
  titles: Title[]
}

const Tabs: React.FC<Props> = ({ titles }) => {
  const [searchParams] = useSearchParams()
  const mode = searchParams.get('mode')

  return (
    <div className={styles.tabs}>
      {titles.map((title) => (
        <Link
          to={`?mode=${title.mode}`}
          key={title.name}
          className={`${styles.btn} ${mode === title.mode && styles.active}`}
        >
          {title.name}
        </Link>
      ))}
    </div>
  )
}

export default Tabs
